<template>
  <v-card :class="{mobile}">
    <div class="card_body">
      <v-layout :column="mobile" :row="!mobile">
        <v-flex :xs8="!mobile && contactFormEnabledOnContactPage" class="contact_col">
          <div v-if="!mobile" class="title">{{ $t('Contact_Us') }}</div>
          <div class="persons_cover">
            <div v-for="(agent, index) in agents" :key="index" class="person"
                 v-bind:class="{'no-max-width': agents.length===1}">
              <v-avatar size="100">
                <img :src="getCdn(`${agent.profile}?width=150&height=150`)" :title="agent.name"/>
              </v-avatar>
              <p class="name">{{ agent.name }}</p>
              <!--              <p class="department">{{agent.department}}</p>-->
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>email</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <a :href="`mailto:${agent.email}`" class="v-list__tile__title">
                      {{ agent.email }}
                    </a>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-icon>phone</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <a :href="`tel:${agent.phone}`" class="v-list__tile__title">
                      {{ agent.phone }}
                    </a>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-for="social in agent.socials"
                  :key="`social-link-${social.social_id}`"
                >
                  <v-list-item-action>
                    <i :class="`fa fa-fw fa-${social.social_type}`"></i>
                  </v-list-item-action>
                  <v-list-item-content>
                    <a :href="social.url" class="v-list__tile__title">{{ social.label }}</a>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </div>
          <a
            v-if="!projectSettings['contact_page_map_disabled']"
            :href="brokerCompany.google_maps_url"
            class="google-map-static__link"
            target="_blank"
            title="Go to Google maps"
          >
            <div
              :style="`background: url(https://maps.googleapis.com/maps/api/staticmap?center=${brokerCompany.lat},${brokerCompany.lng}&zoom=17&size=800x500&maptype=roadmap&markers=color:blue;62.470848,6.335229&key=${googleApiKey}) no-repeat center`"
              class="google-map-static__image"
            ></div>
          </a>
          <v-row>
            <v-col cols="6" lg="8" md="8" sm="6">
              <p class="place_name">{{ brokerCompany.name }}</p>
              <p class="place_address">{{ brokerCompany.address }}</p>
              <p class="place_working">{{ brokerCompany.hours }}</p>
            </v-col>
            <v-col class="text-right pr-0" cols="6" lg="4" md="4" sm="6">
              <img
                v-if="!!brokerCompany.logo"
                :src="getCdn(`${brokerCompany.logo}?height=80&width=999`)"
                class="place_logo"
              />
            </v-col>
          </v-row>
          <v-list>
            <v-list-item v-if="brokerCompany.phone">
              <v-list-item-action>
                <v-icon>phone</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <a
                  :href="`tel:${brokerCompany.phone}`"
                  class="place_phone"
                >{{ brokerCompany.phone }}</a>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="brokerCompany.email">
              <v-list-item-action>
                <v-icon>email</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <a
                  :href="`mailto:${brokerCompany.email}`"
                  class="place_phone"
                >{{ brokerCompany.email }}</a>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex v-if="contactFormEnabledOnContactPage" :xs4="!mobile" class="email_col">
          <contact-form/>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import { cdnUrl } from '@/utils/urls';
import { mapGetters } from 'vuex';
import ContactForm from '@/components/ContactForm.vue';

export default {
  components: { ContactForm },
  props: [
    'brokerCompany',
    'agents',
    'projectSettings',
    'contactsModules',
    'favouriteUnitsList',
  ],
  data() {
    return {
      googleApiKey: 'AIzaSyAdFctfF8iGGvASD8XEkDCwfEhSWck5vEk',
    };
  },
  computed: {
    ...mapGetters('project', ['contactFormEnabledOnContactPage']),
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getCdn(source) {
      return cdnUrl(source);
    },
  },
};
</script>

<style lang="scss">
.contacts_card {
  nav {
    height: auto;
    @supports (padding-left: env(safe-area-inset-left)) {
      padding-left: env(safe-area-inset-left) !important;
      padding-right: env(safe-area-inset-right) !important;
    }
  }

  a {
    text-decoration: none;
  }

  &.v-card.mobile {
    min-height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .card_body {
    .row {
      margin: initial;
    }
  }

  .mobile {
    .contact_col {
      .person {
        max-width: 100%;
      }
    }

    .email_col {
      border-left: none;
    }

    .card_body {
      @supports (padding-left: env(safe-area-inset-left)) {
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
      }
    }
  }

  .flex {
    padding: 27px 20px;
  }

  .contact_col {
    .title {
      margin-bottom: 30px;
    }

    .name,
    .department {
      margin-bottom: 0;
    }

    .name {
      font-size: 1.3em;
    }

    .department {
      font-size: 0.81em;
    }

    .persons_cover {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .person {
      max-width: 49%;
      min-width: 265px;
      margin-bottom: 20px;

      .v-avatar {
        border: 1px solid rgba(55, 50, 50, 0.1);
        margin-bottom: 20px;
        min-width: 100px;
        min-height: 100px;

        img {
          object-fit: cover;
          width: 100px;
          height: 100px;
        }
      }
    }

    .person.no-max-width {
      max-width: none !important;
    }

    .google-map-static__link {
      display: block;
    }

    .google-map-static__image {
      width: 100%;
      height: 300px;
      background-size: cover;
      margin-bottom: 20px;
      border: var(--horizontal-dividing-line);
    }

    .place_name,
    .place_address,
    .place_working {
      margin-bottom: 0;
      font-size: 0.81em;
    }

    .place_name {
      font-size: 1.3em;
      margin-bottom: 0;
      text-transform: uppercase;
    }

    .place_logo {
      max-height: 60px;
    }

    .v-list {
      padding: 0;
      margin-top: 18px;
    }

    .v-list__tile {
      padding: 0;
      height: 36px;
    }

    .v-list__tile__content a {
      color: #464646;
      width: auto;
      max-width: 100%;
    }

    .v-list__tile__action {
      min-width: 36px;
      max-width: 36px;
    }

    .v-list__tile__title {
      color: initial;
    }

    .v-list-item__content {
      a {
        color: initial;
      }

      padding-top: 8px;
      padding-bottom: 8px;
    }

    .v-list-item {
      padding: initial;
      min-height: initial;
    }

    .v-list-item__action {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .email_col {
    border-left: 2px solid #e4e3e3;

    .info_headings {
      margin-bottom: 30px;
      font-size: 1.25rem !important;
      font-weight: 500;
      letter-spacing: .0125em !important;
    }

    .checkbox_units_to_attach {
      padding-left: 32px;
      //margin-top: -26px;
      font-size: 0.875em;
      color: rgba(0, 0, 0, 0.54);
    }

    .v-btn {
      margin: 0;
      //margin-top: 25px;
      width: 200px;
      max-width: 100%;
    }
  }

  .v-input {
    margin-bottom: 10px;
  }

  .v-input__control {
    input {
      border-bottom: 1px solid #e4e3e3;
      width: 100%;
      line-height: 32px;
    }
  }
}
</style>
